import { render } from "./StaffForm.vue?vue&type=template&id=dee720f6&scoped=true"
import script from "./StaffForm.vue?vue&type=script&lang=js"
export * from "./StaffForm.vue?vue&type=script&lang=js"

import "./StaffForm.vue?vue&type=style&index=0&id=dee720f6&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee720f6"]])

export default __exports__